import { Navigate, Route } from "react-router-dom";
import { Routes } from "components/Sentry/Routes";
import Login from "features/Login";
import useDocumentTitle from "hooks/useDocumentTitle";
import { PUBLIC_ROUTE_TITLES } from "config/routes";
import useAuthVerifier from "providers/AuthVerifierProvider/useAuthVerifier";

/**
 * PublicRoutes is the signed out branch of the authenticated shell.
 *
 * Routes that do not depend on authentication are declared in the main route tree
 * instead, so they stay reachable for signed in users.
 */
function PublicRoutes() {
  const { error, onSetError } = useAuthVerifier();

  useDocumentTitle(PUBLIC_ROUTE_TITLES);

  return (
    <Routes>
      <Route path="/" element={<Login error={error} setError={onSetError} />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default PublicRoutes;
